module.exports = __webpack_public_path__ + "assets/img/s3.038adc1a.png";